import {ClassOption, PersonOption} from './attendanceV2Types'
import {AttendanceDisambiguationPick} from './extractAttendanceContext'

export function buildPersonDisambiguationPick(opt: PersonOption): AttendanceDisambiguationPick {
  const personId =
    opt.personId != null
      ? String(opt.personId)
      : opt.studentId != null
        ? String(opt.studentId)
        : undefined

  const section = typeof opt.section === 'string' ? opt.section.trim() : ''

  // Echo back the full identity of the picked candidate so the backend resolves the exact person
  // instead of re-searching the (still ambiguous) name.
  return {
    ...(personId ? {personId} : {}),
    ...(opt.userId != null ? {userId: opt.userId} : {}),
    ...(opt.studentId != null ? {studentId: opt.studentId} : {}),
    ...(opt.name?.trim() ? {name: opt.name.trim()} : {}),
    ...(opt.grade?.trim() ? {grade: opt.grade.trim()} : {}),
    ...(section ? {section} : {}),
    ...(opt.type?.trim() ? {type: opt.type.trim()} : {}),
  }
}

export function buildClassDisambiguationPick(opt: ClassOption): AttendanceDisambiguationPick {
  const name = (opt.label || opt.className || opt.gradeName || '').trim()
  // A subject's id is not a class's, and sending it as `classId` would pin the answer to whichever
  // class happens to share that number. Echo it under its own key.
  const subjectId = opt.kind === 'subject' ? (opt.subjectId ?? opt.classId) : opt.subjectId
  return {
    ...(opt.kind !== 'subject' && opt.classId != null ? {classId: opt.classId} : {}),
    ...(subjectId != null ? {subjectId} : {}),
    ...(name ? {name} : {}),
  }
}
